import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantTaskSharedService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_ParticipantTask_PendingRSUAwardDto,
} from '../../services/wealthlane-award-services';

const useGetPendingRSUAwards = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_ParticipantTask_PendingRSUAwardDto[] | undefined,
  unknown
> => {
  const pendingRSUAwards = useQuery(
    ['getPendingRSUAwards'],
    async () => {
      return await handleRequest(
        ParticipantTaskSharedService.getApiAwardApiAppParticipantTaskPendingRSuAwards()
      );
    },
    {
      cacheTime: 1000 * 60 * 5,
    }
  );

  return pendingRSUAwards;
};

export default useGetPendingRSUAwards;
